import { defineMessages } from 'react-intl';

/** The parts that every director step shares (design directed-video c2, c4, DvSide). */
export const directorMessages = defineMessages({
  // The director at work (c2)
  workingStories: {
    id: 'app.sml.musicVideo.directed.director.workingStories',
    defaultMessage: 'The director is writing three stories',
  },
  workingStyles: {
    id: 'app.sml.musicVideo.directed.director.workingStyles',
    defaultMessage: 'The director is writing three styles',
  },
  workingScript: {
    id: 'app.sml.musicVideo.directed.director.workingScript',
    defaultMessage: 'The director is writing the script, shot by shot',
  },
  workingText: {
    id: 'app.sml.musicVideo.directed.director.workingText',
    defaultMessage:
      'It reads the lyrics line by line, the sections and the energy of the song, and your cast. This takes about a minute. You can leave this page; the ideas wait for you here.',
  },
  workingScriptText: {
    id: 'app.sml.musicVideo.directed.director.workingScriptText',
    defaultMessage:
      'It cuts the song into shots on the beat and writes what happens in each one. This takes about 2 minutes. You can leave this page; the script waits for you here.',
  },
  stepRead: { id: 'app.sml.musicVideo.directed.director.stepRead', defaultMessage: 'Read the song and the lyrics' },
  stepCast: { id: 'app.sml.musicVideo.directed.director.stepCast', defaultMessage: 'Look at the cast' },
  stepStory: { id: 'app.sml.musicVideo.directed.director.stepStory', defaultMessage: 'Read the story' },
  stepWriteStories: {
    id: 'app.sml.musicVideo.directed.director.stepWriteStories',
    defaultMessage: 'Write the stories',
  },
  stepWriteStyles: { id: 'app.sml.musicVideo.directed.director.stepWriteStyles', defaultMessage: 'Write the styles' },
  stepWriteScript: { id: 'app.sml.musicVideo.directed.director.stepWriteScript', defaultMessage: 'Write the shots' },
  aboutMinute: { id: 'app.sml.musicVideo.directed.director.aboutMinute', defaultMessage: 'about 1 min' },
  aboutTwoMinutes: { id: 'app.sml.musicVideo.directed.director.aboutTwoMinutes', defaultMessage: 'about 2 min' },

  // The errors and limits (c4)
  failedStories: {
    id: 'app.sml.musicVideo.directed.director.failedStories',
    defaultMessage:
      '<b>The director could not write the stories.</b> Try again. If it fails again, change the note or the cast.',
  },
  failedStyles: {
    id: 'app.sml.musicVideo.directed.director.failedStyles',
    defaultMessage:
      '<b>The director could not write the styles.</b> Try again. If it fails again, change the note or the story.',
  },
  failedScript: {
    id: 'app.sml.musicVideo.directed.director.failedScript',
    defaultMessage:
      '<b>The director could not write the script.</b> Try again. If it fails again, change the note or the style.',
  },
  failedBudget: {
    id: 'app.sml.musicVideo.directed.director.failedBudget',
    defaultMessage: '<b>The director is busy now.</b> Try again later. Everything is saved.',
  },
  tryAgain: { id: 'app.sml.musicVideo.directed.director.tryAgain', defaultMessage: 'Try again' },
  videoLimit: {
    id: 'app.sml.musicVideo.directed.director.videoLimit',
    defaultMessage:
      '<b>No director runs left for this video.</b> You used all {count}. Pick one of the ideas on screen, or edit it yourself.',
  },
  dayLimit: {
    id: 'app.sml.musicVideo.directed.director.dayLimit',
    defaultMessage:
      '<b>That is enough directing for today.</b> {count} runs a day per workspace. You can go on tomorrow; everything is saved.',
  },
  busy: {
    id: 'app.sml.musicVideo.directed.director.busy',
    defaultMessage: 'The director is working. Try again when it is done.',
  },
  stale: {
    id: 'app.sml.musicVideo.directed.director.stale',
    defaultMessage: 'The video changed on another screen. We loaded it again.',
  },
  demo: { id: 'app.sml.musicVideo.directed.director.demo', defaultMessage: 'The example artist is read only.' },
  failed: { id: 'app.sml.musicVideo.directed.director.failed', defaultMessage: 'That did not work. Try again.' },

  // "Not it?" (c1, d1)
  notIt: { id: 'app.sml.musicVideo.directed.director.notIt', defaultMessage: 'Not it?' },
  noteLabel: { id: 'app.sml.musicVideo.directed.director.noteLabel', defaultMessage: 'A note for the director' },

  // The side panel (DvSide)
  sideTitle: { id: 'app.sml.musicVideo.directed.summary.title', defaultMessage: 'Your directed video' },
  sideCast: { id: 'app.sml.musicVideo.directed.summary.cast', defaultMessage: 'Cast · {count}' },
  sideNoCast: {
    id: 'app.sml.musicVideo.directed.summary.noCast',
    defaultMessage: 'No cast. The director invents the people.',
  },
  sideStory: { id: 'app.sml.musicVideo.directed.summary.story', defaultMessage: 'Story' },
  sideStyle: { id: 'app.sml.musicVideo.directed.summary.style', defaultMessage: 'Style' },
  runsLeft: { id: 'app.sml.musicVideo.directed.summary.runsLeft', defaultMessage: 'Director runs left' },
  runsCount: { id: 'app.sml.musicVideo.directed.summary.runsCount', defaultMessage: '{left} of {total}' },
  runsText: {
    id: 'app.sml.musicVideo.directed.summary.runsText',
    defaultMessage: 'Each new set of ideas, script or shot rewrite is one run. {perVideo} per video, {perDay} per day.',
  },
});
